import { backgroundColor } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { borderColor } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/borderColor";
import { borderRadius } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { borderWidth } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/borderWidth";
import { color } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontSize } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/fontSize";
import { fontStyle } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/fontStyle";
import { fontWeight } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/fontWeight";
import { lineHeight } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/lineHeight";
import { textAlign } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/textAlign";
import { textDecoration } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/textDecoration";
import { textTransform } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/textTransform";
import {
  DesignProp,
  GeneralProp,
} from "@/react/components/shared/BuilderUI/constants/PropCategories";
import { objectAlignment as alignment } from "./objectAlignment";

export const defaultButtonState = {
  name: "Default state",
  nameI18n: "builder_ui.prop_type.styles.default",
  category: [DesignProp, GeneralProp],
  prop: "styles",
  type: "other",
  defaultValue: {
    alignment,
    backgroundColor,
    borderColor,
    borderRadius,
    borderWidth,
    color,
    fontSize,
    fontStyle,
    fontWeight,
    lineHeight,
    textAlign,
    textDecoration,
    textTransform,
  },
} as const;

export const hoverButtonState = {
  name: "Hover state",
  nameI18n: "builder_ui.prop_type.styles.hover",
  category: [DesignProp, GeneralProp],
  prop: "styles",
  type: "other",
  defaultValue: {
    alignment,
    backgroundColor,
    borderColor,
    borderRadius,
    borderWidth,
    color,
    fontSize,
    fontStyle,
    fontWeight,
    lineHeight,
    textAlign,
    textDecoration,
    textTransform,
  },
} as const;
